export default __webpack_public_path__ + "static/media/chat-svg3.82b3eee0.svg";